import { atomWithStorage } from 'jotai/utils';

export const initMessageConversationAtom = atomWithStorage<
  | {
      message: string;
      id: string;
    }
  | undefined
>('messageConversationAtom', undefined);
